import * as React from 'react';
import { useState } from 'react';
import {
    Button,
    CardActions,
    CardContent,
    CircularProgress,
    Typography,
    TextField,
} from '@mui/material';
import { useNotify, Title } from 'react-admin';
import { supabase } from '../providers/supabase/supabase';
import { Link } from 'react-router-dom';
import {
    AuthPageLayout,
    AuthButton,
    OrDivider,
    LogoHeader,
} from './components';

export const CustomForgotPasswordPage = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const notify = useNotify();

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        if (!email) return;

        setLoading(true);

        const { error } = await supabase.auth.resetPasswordForEmail(email, {
            redirectTo:
                'https://kosmojo-hpt-crm.netlify.app/auth-callback.html',
        });

        setLoading(false);

        if (error) {
            notify(`Error: ${error.message}`, { type: 'error' });
        } else {
            notify('Password reset email sent. Check your inbox.', {
                type: 'info',
            });
            setEmail('');
        }
    };

    return (
        <AuthPageLayout maxWidth={400}>
            <Title title="Reset Password" />
            <LogoHeader />

            <form onSubmit={handleSubmit}>
                <CardContent sx={{ width: 300 }}>
                    <Typography
                        variant="h6"
                        component="h1"
                        gutterBottom
                        align="center"
                        sx={{ mb: 1 }}
                    >
                        Reset Password
                    </Typography>
                    <Typography
                        variant="body2"
                        align="center"
                        sx={{
                            mb: 3,
                            color: 'text.secondary',
                        }}
                    >
                        Enter your email address to receive instructions.
                    </Typography>

                    <TextField
                        fullWidth
                        type="email"
                        label="Email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        autoComplete="email"
                        autoFocus
                        required
                        disabled={loading}
                        variant="outlined"
                        sx={{ mb: 2 }}
                    />
                </CardContent>

                <CardActions
                    sx={{ flexDirection: 'column', gap: 1, px: 2, pb: 2 }}
                >
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={loading || !email}
                        fullWidth
                        sx={{ mt: 1 }}
                    >
                        {loading ? (
                            <CircularProgress
                                size={19}
                                thickness={3}
                                sx={{ margin: 0.3 }}
                            />
                        ) : (
                            'Send Reset Instructions'
                        )}
                    </Button>

                    <OrDivider />

                    <AuthButton component={Link} to="/login" disabled={loading}>
                        Back to Login
                    </AuthButton>
                </CardActions>
            </form>
        </AuthPageLayout>
    );
};

// Define a static path if needed for routing
CustomForgotPasswordPage.path = '/forgot-password';
